import { IUploaderContent } from '../redux/contentUploaderModel';

const getThumbnailMedia = (content: IUploaderContent): string => content.previewUrl || content.localSrc || content.fileUrl || '';

export { getThumbnailMedia };
